export interface CompanyPortalConfig {
  // Identity
  slug: string;
  name: string;
  organizationId: string;
  
  // Branding
  branding: {
    logo?: string;
    initials: string;
    primaryColor: string;
    gradientStart: string;
    gradientEnd: string;
    buttonColor?: string;
  };
  
  // Routes
  routes: {
    login: string;
    app: string;
  };
  
  // Features (for future extensibility)
  features?: {
    showPublicTests?: boolean;
    showInvitedTests?: boolean;
    showNotifications?: boolean;
  };
}

// Company configurations
export const COMPANY_CONFIGS: Record<string, CompanyPortalConfig> = {
  innoventure: {
    slug: "innoventure",
    name: "Innoventure",
    organizationId: "d4b5cd3c-483a-4574-9a20-ece44b857de6",
    branding: {
      logo: "https://sekiwtiutnikmdbpiufi.supabase.co/storage/v1/object/public/siteassets/innoventure%20logo.png",
      initials: "I+",
      primaryColor: "#00a65a",
      gradientStart: "#8740f1",
      gradientEnd: "#8740f1",
      buttonColor: "#00a65a",
    },
  routes: {
    login: "/innoventure-login",
    app: "/innoventure-app",
  },
    features: {
      showPublicTests: true,
      showInvitedTests: true,
      showNotifications: true,
    },
  },
};

// Helper to get config by slug
export const getCompanyConfig = (slug: string): CompanyPortalConfig | undefined => {
  return COMPANY_CONFIGS[slug];
};

// Helper to get config by route
export const getCompanyConfigByRoute = (route: string): CompanyPortalConfig | undefined => {
  return Object.values(COMPANY_CONFIGS).find(
    config => config.routes.login === route || config.routes.app === route
  );
};
